exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--top-number:0px}.hovercard{position:absolute;display:none;opacity:0;z-index:1;top:var(--top-number);width:100%;height:100%}.desc-tooltip:hover~.hovercard{display:block;opacity:1}.tooltiptext{display:flex;flex-direction:column;justify-content:flex-start;background-color:#d3eaea;padding:18px;border-radius:5px;color:#343a40;line-height:15px;direction:rtl;text-align:justify;box-shadow:0 1px 5px rgb(0 0 0/60%)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c897a28","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/PublicComponents/DescriptionByTooltip.vue
// module id = 542
// module chunks = 0